

import React from 'react';
import Axios from 'axios';
// import Loader from '../../../../../utils/loader/loaders';
import { withRouter } from 'react-router-dom';
import KenTable from "../../../../global_components/KenTable/kentable";
import KenContainerNavbar from "../../../../global_components/KenContainerNav";
// import removeCircle from '../../../../../assets/images/remove_circle.png';
// import removeCircle from '../../../../../assets/icons/delete-row.svg';
import removeCircle from '../../../../Assets/icons/black-cross.png';
// import addCircle from '../../../../../assets/images/add_circle.png';
import '../../../../SCSS/invoice-template.scss';
import '../../../../SCSS/payroll.scss';
import { Table, Row } from 'reactstrap';
import moment from 'moment';
import addRowPlus from '../../../../Assets/icons/addrow-icon.svg';
import { Alert } from 'rsuite';
// import zq_api from '../../../../../utils/api-service';
import Button from '@material-ui/core/Button';
import Checkbox from "@material-ui/core/Checkbox";
import KeyboardBackspaceSharpIcon from "@material-ui/icons/KeyboardBackspaceSharp";
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { SelectPicker } from 'rsuite';
class Payslip extends React.Component {
    constructor() {
        super();
        // this.zq_api = new zq_api();
        this.state = {
            printTime: '',
            earningDetails: [],
            deductionDetails: [],
            extraTotalItemDetails: [],
            TableView: true,
            deleteICO: true,
            branchDetails: [],
            showIcons: false,
            paginationView: false,
            useremail: localStorage.getItem('email'),
            userID: localStorage.getItem('userID'),
            phone: localStorage.getItem('phone'),
            channel: localStorage.getItem('channel'),
            env: JSON.parse(localStorage.getItem('env')),
            environment: JSON.parse(localStorage.getItem('environment')),
            authToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoicHIuYWRtaW4uYWxsQHplbnFvcmUuY29tIiwiVXNlcklkIjoiNjEzMWY3MmM4NTEwMTM1NDIyOTBmMWVhIiwiaWF0IjoxNjMwNjY0ODQ4fQ.X0gWTq-23DBuhjM8Jm-5IEb7fEqsOlRiHU31-HvmNuI",
            orgId: "606ac70479dbb25447375fa8",
            orgName: localStorage.getItem('orgName'),
            _id: '',
            noProg: 'Fetching Details..',
            isLoader: false,
            payslipTableData: [],
            formBtns: [
                // {
                //     "category": "button",
                //     "type": "clear",
                //     "label": "Clear",
                //     "class": "secondary-btn form-clear-btn"
                // },
                {
                    "category": "button",
                    "type": "save",
                    "label": "Save",
                    "class": "secondary-btn form-save-btn"
                },
                {
                    "category": "button",
                    "type": "submit",
                    "label": "Submit",
                    "class": "primary-btn form-submit-btn",
                }],
            containerNav: {
                isBack: false,
                name: '',
                isName: true,
                total: 0,
                isTotalCount: false,
                isSearch: false,
                isSort: false,
                isPrint: false,
                isDownload: false,
                isShare: false,
                isNew: false,
                newName: "New",
                masterPayslipName: "Submit",
                isMasterPayslipName: true,
                isSubmit: false,
            },
            earningsChecked: false,
            deductionChecked: false,
            activeTab: 0,
            totalOptions: [
                { "value": "Net Salary", "label": "Net Salary" },
                { "value": "Salary Payout", "label": "Salary Payout" },
                { "value": "Payout Ratio", "label": "Payout Ratio" },
                { "value": "Total CTC", "label": "Total CTC" },
                { "value": "Others", "label": "Others" }
            ]
        }
    }

    componentDidMount() {
        this.getTime();
        this.getPayslip();
    }
    getTime = () => {

        setInterval(() => {
            this.setState({
                printTime: moment(new Date()).format('DD/MM/YYYY (hh:mm:ss A)').toLocaleString()
            })
        }, 1000)
    }
    onCheckbox = (e, type) => {
        if (type === "Earnings") {
            this.setState({ earningsChecked: !this.state.earningsChecked }, () => {
                let tableData = this.state.earningDetails;
                tableData.map((item) => {
                    item.checked = this.state.earningsChecked;
                });
                this.setState({ earningDetails: tableData });
            });
        }
        else if (type === 'Deductions') {
            this.setState({ deductionChecked: !this.state.deductionChecked }, () => {
                let tableData = this.state.deductionDetails;
                tableData.map((item) => {
                    item.checked = this.state.deductionChecked;
                });
                this.setState({ deductionDetails: tableData });
            });
        }

    };

    onRowCheckBox = (e, row, index, type) => {
        console.log(e);
        // e.preventDefault();
        if (type === 'Earnings') {
            let tableData = this.state.earningDetails;
            tableData[index].checked = !row.checked;
            let selectedItem = [];
            this.setState({ earningDetails: tableData, selectedItem: selectedItem }, () => {
                tableData.map((item) => {
                    if (item.checked) {
                        selectedItem.push(item);
                    }
                });
                this.setState({ selectedItem: selectedItem }, () => {
                    if (this.state.earningDetails.length == this.state.selectedItem.length) {
                        this.setState({ earningsChecked: true });
                    } else {
                        this.setState({ earningsChecked: false });
                    }
                });
            });
        }
        else if (type === 'Deductions') {
            let tableData = this.state.deductionDetails;
            tableData[index].checked = !row.checked;
            let selectedItem = [];
            this.setState({ deductionDetails: tableData, selectedItem: selectedItem }, () => {
                tableData.map((item) => {
                    if (item.checked) {
                        selectedItem.push(item);
                    }
                });
                this.setState({ selectedItem: selectedItem }, () => {
                    if (this.state.deductionDetails.length == this.state.selectedItem.length) {
                        this.setState({ deductionChecked: true });
                    } else {
                        this.setState({ deductionChecked: false });
                    }
                });
            });
        }

    };

    getPayslip = () => {
        let config = {
            headers: {
                "Authorization": this.state.authToken,
                'Content-Type': 'application/json'
            }
        }

        Axios.get(`https://api.zenqore.com/payroll/uat/hkbk/setup/payrollPayslipLineItems`, config)
            .then((response) => {
                console.log("response of get payroll api", response.data);
                if (response.data.length > 0) {
                    // console.log(response.data._id)
                    // this.setState({ _id: response.data._id })
                    let Response = []
                    Response = response.data;
                    Axios.get(`https://api.zenqore.com/payroll/uat/hkbk/masters/payslip`, config)
                        .then((payslipRes) => {
                            console.log(payslipRes)
                            var data = [];
                            let data2 = []
                            let data3 = []
                            Response.sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()).map((item, index) => {

                                if (item.type == "Earning") {
                                    data.push({
                                        "row": index + 1,
                                        "ID": item.id,
                                        "Earnings": item['name']
                                    })
                                } else if (item.type == "Deduction") {
                                    data2.push({
                                        "row": index + 1,
                                        "ID": item.id,
                                        "Deductions": item['name']
                                    })
                                }
                            })
                            if (payslipRes.data.data.length > 0) {
                                payslipRes.data.data.map(pitem => {
                                    data.map((item, i) => {
                                        if (pitem.id == item.ID) {
                                            data[i]['checked'] = true
                                        }
                                    })
                                    data2.map((item, i) => {
                                        if (pitem.id == item.ID) {
                                            data2[i]['checked'] = true
                                        }
                                    })
                                    if (pitem.type == "extra") {
                                        data3.push({
                                            "select": pitem.id,
                                            "value": pitem['name']
                                        })
                                    }
                                })

                            }
                            this.setState({ earningDetails: data, extraTotalItemDetails: data3.length == 0 ? [{ value: "", selected: "" }] : data3 })
                            // let data2 = []
                            // api_data_deduction.map(item => {
                            //     data2.push({
                            //         "Deductions": item['name']
                            //     })
                            // })
                            this.setState({ deductionDetails: data2 })

                            console.log(data)
                            let tableData = [];
                            data.map(item => {
                                tableData.push({
                                    "Earnings": item['Earnings'],
                                    "Deductions": item["Deductions"]
                                })
                            })
                            this.setState({ payslipTableData: tableData, isLoader: false })
                        })
                    // var api_data_earning = response.data.multipleEarningItemsData;
                    // var api_data_deduction = response.data.multipleDeductionsItemsData;
                    // var api_data_earning = [
                    //     { "isFixedEarnings": false, "earningItem": "Basic", "coaCode": "4.1.10.3" },
                    //     { "isFixedEarnings": false, "earningItem": "HRA", "coaCode": "4.1.10.4" },
                    //     { "isFixedEarnings": false, "earningItem": "Conveyance Allowance", "coaCode": "4.1.10.5" },
                    //     { "isFixedEarnings": false, "earningItem": "Medical Allowance", "coaCode": "4.1.10.6" },
                    //     { "isFixedEarnings": false, "earningItem": "Other Allowance", "coaCode": "4.1.10.7" },
                    // ]

                    // var api_data_deduction = [
                    //     { "isFixedDeduction": false, "deductionItem": "Provident Fund", "coaCode": "4.1.11.3" },
                    //     { "isFixedDeduction": false, "deductionItem": "Professional Tax", "coaCode": "4.1.11.4" },
                    //     { "isFixedDeduction": false, "deductionItem": "Employee State Insurance", "coaCode": "4.1.11.5" },
                    //     { "isFixedDeduction": false, "deductionItem": "TDS", "coaCode": "4.1.11.6" },
                    //     { "isFixedDeduction": false, "deductionItem": "Other Deductions", "coaCode": "4.1.11.6" }
                    // ];

                }
            })
            .catch(err => {
                this.setState({ earningDetails: [], deductionDetails: [], noProg: 'No Data', isLoader: false })
                Alert.error("Failed to load! Please try later.")
            })

    }

    handleAddRow = (idx) => {
        let { extraTotalItemDetails } = this.state;
        console.log(this.state.extraTotalItemDetails.length)
        const item = {
            value: '',
            selected: ''
        };
        // if (extraTotalItemDetails.length <= 6) {
        extraTotalItemDetails.splice(idx + 1, 0, item)
        this.setState({
            extraTotalItemDetails
        });
        // }
        // else {
        //     Alert.info("The total number of Payroll Earning Items should not exceed 7.")
        // }
    };
    handleAddRowDeduct = (idx) => {
        let { deductionDetails } = this.state;
        console.log(deductionDetails.length)
        const item = {
            Deductions: ''
        };
        if (deductionDetails.length <= 6) {
            deductionDetails.splice(idx + 1, 0, item)
            this.setState({
                deductionDetails
            });
        } else {
            Alert.info("The total number of Payroll Deduction Items should not exceed 7.")
        }
    };
    handleRemoveRow = (idx, item) => {
        let { extraTotalItemDetails } = this.state;
        console.log(extraTotalItemDetails.length)
        // let earnItem = item.Earnings
        // if (earnItem.toLowerCase() != 'basic' && earnItem.toLowerCase() != 'hra') {
        extraTotalItemDetails.splice(idx, 1)
        this.setState({
            extraTotalItemDetails
        });
        // }
        // else {
        //     Alert.info(`${item.Earnings} is Mandatory`)
        // }
    };
    handleRemoveRowDeduct = (idx) => {
        let { deductionDetails } = this.state;
        if (deductionDetails.length >= 5) {
            deductionDetails.splice(idx, 1)
            this.setState({
                deductionDetails
            });
        } else {
            Alert.info("4 Deduction Items are Mandatory ")
        }
    };
    handleChange = idx => e => {
        var { value } = e.target;
        var itemName = /^[a-zA-Z ]+$/
        if (itemName.test(value) || value == "") {
            let extraTotalItemDetails = [...this.state.extraTotalItemDetails];
            extraTotalItemDetails[idx] = {
                'value': value,
                'select': extraTotalItemDetails[idx]['select']
            };
            this.setState({
                extraTotalItemDetails
            }, () => { console.log(extraTotalItemDetails) });
        }
        else {
            Alert.info("Only Text Values are allowed")
        }
    };
    onSelect = (value, item, event, idx) => {
        let extraTotalItemDetails = [...this.state.extraTotalItemDetails];
        extraTotalItemDetails[idx] = {
            'select': value,
            'value': extraTotalItemDetails[idx]['value']
        };
        this.setState({
            extraTotalItemDetails
        }, () => { console.log(extraTotalItemDetails) });
    }
    handleChangeDeduct = idx => e => {
        const { name, value } = e.target;
        var itemName = /^[a-zA-Z ]+$/
        if (itemName.test(value) || value == "") {
            const deductionDetails = [...this.state.deductionDetails];
            deductionDetails[idx] = {
                'Deductions': value
            };
            this.setState({
                deductionDetails
            }, () => { console.log(deductionDetails) });
        } else {
            Alert.info("Only Text Values are allowed")
        }
    };
    submitED = () => {
        // this.setState({ payslipTableData: [] })
        let { earningDetails, deductionDetails, useremail } = this.state;
        console.log(earningDetails, deductionDetails);
        let multipleEarning = [];
        let multipleDeductions = [];
        earningDetails.map(item => {
            if (item.checked != undefined) {
                if (item.checked) {
                    multipleEarning.push(item)
                }
            }
        })
        deductionDetails.map(item => {
            if (item.checked != undefined) {
                if (item.checked) {
                    multipleDeductions.push(item)
                }
            }
        })
        if (multipleEarning.length > 0 && multipleDeductions.length > 0) {
            console.log(multipleDeductions, multipleEarning)
            this.submitAPI(multipleEarning, multipleDeductions)
        }
        else {
            Alert.info(`Please select Payslip ${multipleEarning.length > 0 ? '' : 'Earnings'}${(multipleEarning.length == 0 && multipleDeductions.length == 0) ? ' and ' : ''}${multipleDeductions.length > 0 ? '' : 'Deductions'} Item`)
            // this.setState({ isLoader: false });
            // this.getPayslip();
        }
    }
    submitAPI = (earnings, deductions) => {
        this.setState({ isLoader: true });
        let payload = {
            earnings: [],
            deductions: [],
            totalItems: this.state.extraTotalItemDetails
        }
        payload.earnings = earnings;
        payload.deductions = deductions;
        payload.orgId = `${this.state.orgId}`;
        // payload.orgEmail = `${this.state.useremail}`;
        // payload.orgName = `${this.state.orgName}`;
        payload._id = `${this.state._id}`;
        payload.userId = this.state.userID;
        console.log(this.state.extraTotalItemDetails);
        console.log(JSON.stringify(payload));

        let config = {
            headers: {
                "Authorization": this.state.authToken
            }
        }
        Axios.post(`${this.state.env['zqBaseUri']}/masters/payslip`, payload, config)
            .then(response => {
                Alert.success("Payslip Line Items has been generated successfully.")
                this.setState({ isLoader: false })
                this.getPayslip();
            })
            .catch(err => {
                Alert.error("Operation Failed ! Please try later. ")
                this.setState({ noProg: "No Data", isLoader: false })
                this.getPayslip();
            })
        // this.zq_api.post(apiDetails).then(res => {
        //     console.log(res)
        // if (res.failed == undefined) {
        //     Alert.success(res.message)
        //     this.setState({ isLoader: false })
        //     this.getPayslip();
        // }
        // else {
        //     if (res.failed == true) {
        //         Alert.error(res.error.response.data.message)
        //     }
        //     // console.log("error occured in payroll submit API");
        //     // Alert.error("Operation Failed ! Please try later. ")
        //     this.setState({ noProg: "No Data", isLoader: false })
        //     this.getPayslip();
        // }
        // })
    }
    handleTabChange = (event, value) => {
        console.log(value, event)
        this.setState({ activeTab: value })
    }
    render() {
        return (<React.Fragment >
            {/* {this.state.isLoader ? <Loader /> : null} */}

            < div className="setup-wrap master-payslip" >
                <div className="invoice-page-wrapper new-table-wrap">
                    {/* {this.state.containerNav == undefined ? null : <React.Fragment><ContainerNavbar containerNav={this.state.containerNav} onSubmitPayslip={this.submitED} /><div className="print-time">{this.state.printTime}</div></React.Fragment>} */}
                    <div className="trial-balance-header-title">
                        <KeyboardBackspaceSharpIcon className="keyboard-back-icon" onClick={() => { this.props.history.push('/main/dashboard') }} style={{
                            marginRight: '5px',
                            cursor: 'pointer',
                            marginTop: '0px'
                        }} />
                        <p className="top-header-title" onClick={() => { this.props.history.push('/main/dashboard') }}>| Payslip Structure</p>
                    </div>
                    {/* {this.state.containerNav == undefined ? null : <React.Fragment><ContainerNavbar containerNav={this.state.containerNav} onSubmitPayslip={this.submitED} /><div className="print-time">{this.state.printTime}</div></React.Fragment>} */}

                    {this.state.containerNav == undefined ? null : (
                        <React.Fragment>
                            <KenContainerNavbar
                                containerNav={this.state.containerNav}
                                onSubmitPayslip={this.submitED}
                            />
                            <div className="print-time">{this.state.printTime}</div>
                        </React.Fragment>

                    )}
                    {/* <div className="tab-form-wrapper" style={{ top: '-45px' }}>
                        {this.state.formBtns.map(item => {
                            return <Button type={item.type} class={item.class} >{item.label}</Button>
                        })}
                    </div> */}
                    <div className="tab-wrapper">
                        <Paper square>
                            <React.Fragment>
                                <Tabs
                                    value={this.state.activeTab}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    onChange={this.handleTabChange}
                                >
                                    <Tab label="Payslip Items" />
                                    <Tab label="Total Items" />
                                </Tabs>
                                {/* <TabPanel value={this.state.activeTab} index="0"></TabPanel>
                                <TabPanel value={this.state.activeTab} index="1"></TabPanel> */}
                                <div className="table-wrapper" style={{
                                    marginTop: "0px",
                                    paddingTop: '0px'
                                }}>
                                    {this.state.activeTab == 0 ? <React.Fragment>
                                        {this.state.payslipTableData.length == 0 ? <p className="noprog-txt">{this.state.noProg}</p> : <React.Fragment>
                                            <div className="payslip-table-parent" >
                                                {/* <p className="text-payslipHeader">Payslip Items</p> */}
                                                <div className="payslipTables" style={{ top: '0px' }}>

                                                    <div className="tableEarnings" >

                                                        <Table className="zq-table-wrap">
                                                            <thead className="zq-table-heading">
                                                                <tr>
                                                                    <th className="tableHeader" style={{
                                                                        width: '10px',
                                                                        paddingRight: '10px'
                                                                    }} key={0}>
                                                                        <Checkbox
                                                                            checked={this.state.earningsChecked}
                                                                            name="checkedF"
                                                                            onChange={(e) => this.onCheckbox(e, 'Earnings')}
                                                                            indeterminate={!this.state.earningsChecked}
                                                                            color="primary"
                                                                        />
                                                                    </th>

                                                                    <th className="tableHeader">ID</th>
                                                                    <th className="tableHeader">Earnings</th>
                                                                </tr>
                                                            </thead>

                                                            <tbody className="zq-table-body">
                                                                {this.state.earningDetails.map((item, idx) => {
                                                                    return (<React.Fragment>
                                                                        <tr>
                                                                            <td key={idx + item}>
                                                                                <Checkbox
                                                                                    name={idx}
                                                                                    checked={
                                                                                        item.checked != undefined ? item.checked : false
                                                                                    }
                                                                                    onChange={(e) => this.onRowCheckBox(e, item, idx, 'Earnings')}
                                                                                    id={idx}
                                                                                    color="primary"
                                                                                />

                                                                            </td >
                                                                            <td>{item.ID}</td>
                                                                            <td style={{ padding: "0px", position: "relative" }} >
                                                                                <input
                                                                                    type="text"
                                                                                    name="name"
                                                                                    placeholder="Enter Earnings"
                                                                                    value={this.state.earningDetails[idx].Earnings}
                                                                                    // onChange={this.handleChange(idx)}
                                                                                    className="form-control"
                                                                                    readOnly={true}
                                                                                />
                                                                                {/* {this.state.earningDetails && this.state.deleteICO ?
                                                                    <img src={removeCircle} className="remove-row-icon payslip-remove" onClick={() => this.handleRemoveRow(idx, item)} alt="Delete Item" title="Delete item" style={{ position: "absolute", right: "-40px", top: "15px" }} /> : null} */}

                                                                            </td>
                                                                        </tr>
                                                                    </React.Fragment>
                                                                    )
                                                                })}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                    <div className="tableDeuction" style={{ paddingBottom: "10px" }}>
                                                        <Table className="zq-table-wrap" >
                                                            <thead className="zq-table-heading">
                                                                <tr>
                                                                    <th className="tableHeader" style={{
                                                                        width: '10px',
                                                                        paddingRight: '10px'
                                                                    }} key={0}>
                                                                        <Checkbox
                                                                            checked={this.state.deductionChecked}
                                                                            name="checkedF"
                                                                            onChange={(e) => this.onCheckbox(e, 'Deductions')}
                                                                            indeterminate={!this.state.deductionChecked}
                                                                            color="primary"
                                                                        />
                                                                    </th>
                                                                    <th className="tableHeader">ID</th>
                                                                    <th className="tableHeader" >Deductions</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody className="zq-table-body">
                                                                {this.state.deductionDetails.map((item, idx) => {
                                                                    return (<React.Fragment> <tr>
                                                                        <td key={idx + item}>
                                                                            <Checkbox
                                                                                name={idx}
                                                                                checked={
                                                                                    item.checked != undefined ? item.checked : false
                                                                                }
                                                                                onChange={(e) => this.onRowCheckBox(e, item, idx, 'Deductions')}
                                                                                id={idx}
                                                                                color="primary"
                                                                            />

                                                                        </td >
                                                                        <td>{item.ID}</td>
                                                                        <td style={{ padding: "0px", position: "relative" }}>
                                                                            <input
                                                                                type="text"
                                                                                name="name"
                                                                                placeholder="Enter Deductions"
                                                                                value={this.state.deductionDetails[idx].Deductions}
                                                                                // onChange={this.handleChangeDeduct(idx)}
                                                                                className="form-control"
                                                                                readOnly={true}
                                                                            />
                                                                            {/* {this.state.deductionDetails && this.state.deleteICO ?
                                                                <img src={removeCircle} className="remove-row-icon payslip-remove" onClick={() => this.handleRemoveRowDeduct(idx, item)} alt="Delete Item" title="Delete item" style={{ position: "absolute", right: "-40px", top: "15px" }} /> : null} */}
                                                                        </td>
                                                                    </tr>
                                                                    </React.Fragment>
                                                                    )
                                                                })
                                                                }
                                                            </tbody>
                                                        </Table>

                                                    </div>
                                                </div>
                                            </div>
                                        </React.Fragment>}
                                    </React.Fragment> : <React.Fragment>
                                        <div className="invoice-page-wrapper new-table-wrap">
                                            <div className="table-wrapper">

                                                <div className="payslip-table-parent" >
                                                    <div className="payslipTables" >
                                                        <div className="tableEarnings" >
                                                            <Table className="zq-table-wrap">
                                                                <thead className="zq-table-heading">
                                                                    <tr>
                                                                        {/* <div className="payslip-header"> */}
                                                                        <div className="payslip-Header">
                                                                            <div className="payslip-Header2">
                                                                                Description
                                                                            </div>
                                                                            <div className="payslip-Header2">
                                                                                Mapped To
                                                                            </div>
                                                                        </div>
                                                                        {/* <th className="tableHeader">Description</th>
                                                                        <th className="tableHeader">Mapped To</th> */}
                                                                        {/* <th className="tableHeader">Mapped To</th>
                                                                        </div> */}
                                                                    </tr>
                                                                </thead>

                                                                <tbody className="zq-table-body">
                                                                    {this.state.extraTotalItemDetails.map((item, idx) => (
                                                                        <React.Fragment>
                                                                            <tr>
                                                                                <td style={{ padding: "0px", position: "relative" }} >
                                                                                    <input
                                                                                        type="text"
                                                                                        name="name"
                                                                                        placeholder="Enter Description"
                                                                                        value={this.state.extraTotalItemDetails[idx].value}
                                                                                        onChange={this.handleChange(idx)}
                                                                                        className="form-control"
                                                                                        style={{ float: "left", width: '50%' }}
                                                                                    // readOnly={(this.state.extraTotalItemDetails[idx].Earnings == 'Basic' || this.state.extraTotalItemDetails[idx].Earnings == 'HRA') ? true : false}
                                                                                    />
                                                                                    <div className={`input-wrap material-select-ui remove-input-margin`}
                                                                                        style={{ float: "left", width: '50%', margin: "0px !important" }}><SelectPicker className="select-input-wrap"
                                                                                            data={this.state.totalOptions}
                                                                                            onSelect={(value, item, event) => this.onSelect(value, item, event, idx)}
                                                                                            placeholder="Select"
                                                                                            defaultValue={this.state.extraTotalItemDetails[idx].select}
                                                                                        />
                                                                                    </div>
                                                                                    {this.state.extraTotalItemDetails && this.state.deleteICO ?
                                                                                        <img src={removeCircle} className="remove-row-icon payslip-remove" onClick={() => this.handleRemoveRow(idx, item)} alt="Delete Item" title="Delete item" style={{ position: "absolute", right: "-40px", top: "15px" }} /> : null}
                                                                                    {this.state.extraTotalItemDetails.length - 1 == idx ?
                                                                                        <React.Fragment>
                                                                                            <img src={removeCircle} className="remove-row-icon payslip-remove" onClick={() => this.handleRemoveRow(idx, item)} alt="Delete Item" title="Delete item" style={{ position: "absolute", right: "-40px", top: "15px" }} />
                                                                                            <div className="payslip-additem-box" style={{ border: "none !important", boxShadow: "none !important", clear: "both" }}>
                                                                                                <div className="add-icon-wrap" onClick={() => this.handleAddRow(idx)}>
                                                                                                    <img src={addRowPlus} className="addRowImg"></img>
                                                                                                    <p className="addRow-text">Add Row</p>
                                                                                                </div>
                                                                                            </div>
                                                                                            {/* <img src={addCircle} className="invoice-addNewItem" onClick={() => this.handleAddRow(idx)} alt="Add Item" title="Add New item" style={{ position: "absolute", right: "-65px", top: "15px" }} /> */}
                                                                                        </React.Fragment>
                                                                                        : ""}
                                                                                </td>
                                                                            </tr>
                                                                        </React.Fragment>
                                                                    ))}
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </React.Fragment>}


                                </div>
                            </React.Fragment>
                        </Paper>
                    </div>
                </div>
            </div>

        </React.Fragment >)
    }
}
export default withRouter(Payslip);